function init(root = document) {
  const elements = root.querySelectorAll('.sf-reveal:not(.is-visible)');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) {
    elements.forEach((el) => el.classList.add('is-visible'));
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -10% 0px' });
  elements.forEach((el) => observer.observe(el));
}

init();
document.addEventListener('shopify:section:load', (event) => init(event.target));
